import { authLogout } from "../../../store/actions/authActions";
import { clearMessage, setMessage } from "../../../store/actions/dialogActions";
import { clearGroups } from "../../../store/actions/groupsActions";
import { setNotifications } from "../../../store/actions/notificationActions";
import API from "../../../store/api";
import { getAllGroups } from "./getAllGroups";

export const deleteGroup = (id, bearerAuth, formFunction) => {
  return async dispatch => {

    dispatch(setMessage({ type: 'LOAD' }))

    API.delete(`/api/portal/groups/${id}`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .ok(res => res.status === 200 || res.status === 401)
      .then((response) => {
        if (response.status === 200) {
          dispatch(clearMessage)
          dispatch(getAllGroups(bearerAuth))
          dispatch(setNotifications({
            type: 'success',
            message: 'Successfully deleted.'
          }))
          formFunction()
        } else if (response.status === 401) {
          dispatch(clearGroups);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          }
        }
        dispatch(setMessage({
          title: 'Delete Group Failed',
          message: message,
          type: 'ERR',
        }))
      })
  }
}